import {
  ComponentAddTargetArea,
  ComponentMenu,
} from '../components-menu/components-add-menu';
import { useComponentMenu } from '../components-menu/component-menu.hooks';
import { COLUMN_COMPONENT_TYPES } from '../component.constants';
import {
  AddComponentTemplate,
  ComponentMenuRenderProp,
} from '../components-menu/components-menu.constants';
import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import { ColumnAddMenuWrapper } from './columns.style';
import {
  ComponentPlusLine,
  ComponentPlusToggle,
  ComponentPlusWrapper,
} from '../components.style';
import ActivityBuilderInlineSvg from 'approot/shared/inline-svg/activity-builder/activity-builder-inline-svg';

type Props = {
  addComponentToColumn: (props: AddComponentTemplate) => void;
  canRenderMenu: boolean;
} & ComponentMenuRenderProp;

export const ColumnAddMenu = ({
  addComponentToColumn,
  render,
  canRenderMenu,
}: Props) => {
  const { menu } = useComponentMenu({
    addComponent: addComponentToColumn,
    componentFilter: COLUMN_COMPONENT_TYPES,
  });
  return (
    <ComponentMenu
      menuItems={menu}
      render={render}
      canRenderMenu={canRenderMenu}
    />
  );
};

export const ColumnComponentAddMenuTarget = ({
  isLastItem,
  componentId,
  columnId,
  columnComponentId,
  addComponent,
}: {
  isLastItem: boolean;
  componentId: string;
  columnId: string;
  columnComponentId: string;
  addComponent: (props: AddComponentTemplate) => void;
}) => {
  const { activeComponent, setActiveComponent, isAddDrawerActive } =
    useActivityBuilderContext();

  const displayAddTarget =
    isAddDrawerActive() &&
    activeComponent?.id === componentId &&
    activeComponent?.column?.id === columnId;

  return isLastItem ? (
    <>
      {displayAddTarget ? (
        <ComponentAddTargetArea />
      ) : (
        <ColumnAddMenuWrapper>
          <ComponentPlusLine />
          <ColumnAddMenu
            canRenderMenu={displayAddTarget}
            addComponentToColumn={props => addComponent(props)}
            render={onClick => (
              <ComponentPlusWrapper>
                <ComponentPlusLine />
                <ComponentPlusToggle
                  data-selector="add-component"
                  aria-label="Add a component"
                  onClick={e => {
                    setActiveComponent({
                      id: componentId,
                      column: {
                        id: columnId,
                        componentId: columnComponentId,
                      },
                    });
                    onClick(e);
                  }}
                >
                  <ActivityBuilderInlineSvg
                    id="icon_plus_active"
                    width={20}
                    height={20}
                  />
                </ComponentPlusToggle>
              </ComponentPlusWrapper>
            )}
          />
        </ColumnAddMenuWrapper>
      )}
    </>
  ) : displayAddTarget ? (
    <ComponentAddTargetArea />
  ) : null;
};
